import * as Availity from './realTimeEligibility/availity';
import { BaseItem, Nullable } from './common';

export enum Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  NotFound = 'NOT_FOUND',
  RequestError = 'REQUEST_ERROR',
  Unknown = 'UNKNOWN',
}

export type QueryResponse =
  | object
  | { coverage: Availity.DetailedCoverage }
  | { coveragesSearchResult: Availity.CoveragesSearchResult }
  | { coverageSearchError: Availity.CoverageSearchError };

export interface BaseInsuranceRteRequest
  extends Nullable<{
    payerId: string;
    groupNumber: string;
    providerFirstName: string;
    providerLastName: string;
    providerNpi: string;
    patientFirstName: string;
    patientLastName: string;
    patientDateOfBirth: string;
    patientGender: string;
    relationshipToSubscriber: string;
    memberId: string;
    serviceType: string;
  }> {
  patientInsuranceInformationId: string;
  status: Status;
  queryResponse: QueryResponse;
}

export type InsuranceRteRequest = BaseItem & BaseInsuranceRteRequest;

export type FindAllOptions = {
  patientInsuranceInformationId: string;
  encounterId?: string;
  limit?: number;
};
